import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

class AdminBoatForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }
    render() {
        const boat = this.props.boat;
        return (
            <li key={boat._id} className='boatListItem'>
                <Formik
                    initialValues={{ name: boat.name, type: boat.type, userId: boat.userId, lat: boat.lat, long: boat.long, }}
                    validationSchema={Yup.object({
                        name: Yup.string()
                            .required('Veuillez renseigner un nom'),
                        type: Yup.string()
                            .required('Veuillez renseigner un type'),
                        userId: Yup.string()
                            .required('Veuillez renseigner un user'),
                        lat: Yup.string()
                            .required('Veuillez renseigner une latitude'),
                        long: Yup.string()
                            .required('Veuillez renseigner une longitude'),
                    })}
                    onSubmit={(values) => {
                        console.log(values)
                        this.props.submitBoat(values);
                    }}>
                    <Form>
                        <h2 className='boatName'> <Field name="name" type="text" placeholder="Bateau"></Field>
                            <span><Field name="type" type="text" placeholder="Bateau"></Field></span></h2>
                        User : <Field name="userId" type="text" placeholder="User ID"></Field>



                        <div className='boatInfo'><span><Field name="lat" type="text" placeholder="Bateau"></Field></span>,
                            <span><Field name="long" type="text" placeholder="Bateau"></Field></span></div>
                        <div className="boatInfo"><span className="label">Speed : </span>{boat.speed}</div>
                        <div className="boatInfo"><span className="label">Beached : </span>{boat.onland ? 'true' : 'false'}</div>

                        <div className='boatInfo'><span className="label">Sails : </span>{boat.sails ? 'true' : 'false'}, <span className="label">Anchor : </span>{boat.anchor ? 'true' : 'false'}</div>
                        <div className="boatInfo"><span className="label">Bearing : </span>{boat.bearing}, <span className="label">Desired : </span>{boat.desiredBearing}</div>
                        <div className="boatInfo"><span className="label">Last Update : </span>{boat.lastUpdate}, <span className="label">Weather Update : </span>{boat.lastWeatherUpdate}</div>
                        <div className="boatInfo"><span className="label">Distance Total : </span>{boat.distanceTotal}</div>
                        <div className="formError">
                            <p><ErrorMessage name="name" /></p>
                            <p><ErrorMessage name="type" /></p>
                            <p><ErrorMessage name="userId" /></p>
                            <p><ErrorMessage name="lat" /></p>
                            <p><ErrorMessage name="long" /></p>
                        </div>
                        <input type="submit" value="Valider" />
                    </Form>
                </Formik>
            </li>
        );
    }
}


export default AdminBoatForm;
